import React from 'react';
import { PRODUCT_GRID_VIEW_UI_MODES, } from '../utils/productGridView';
var MODE_LABELS = {
    grid6: '6 products per row',
    grid8: '8 products per row',
};
var IconGrid8 = function () { return (React.createElement("svg", { viewBox: "0 0 24 24", width: "22", height: "22", "aria-hidden": "true" },
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("line", { x1: "7.5", y1: "3", x2: "7.5", y2: "21", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "12", y1: "3", x2: "12", y2: "21", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "16.5", y1: "3", x2: "16.5", y2: "21", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "3", y1: "12", x2: "21", y2: "12", stroke: "currentColor", strokeWidth: "1" }))); };
var IconGrid6 = function () { return (React.createElement("svg", { viewBox: "0 0 24 24", width: "22", height: "22", "aria-hidden": "true" },
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("line", { x1: "9", y1: "3", x2: "9", y2: "21", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "15", y1: "3", x2: "15", y2: "21", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "3", y1: "9", x2: "21", y2: "9", stroke: "currentColor", strokeWidth: "1" }),
    React.createElement("line", { x1: "3", y1: "15", x2: "21", y2: "15", stroke: "currentColor", strokeWidth: "1" }))); };
var ICONS = {
    grid6: IconGrid6,
    grid8: IconGrid8,
};
export var ProductGridViewToggle = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (React.createElement("div", { className: "product-grid-view-toggle", role: "group", "aria-label": "View" },
        React.createElement("span", { className: "product-grid-view-toggle__label desktop-only" }, "View"),
        PRODUCT_GRID_VIEW_UI_MODES.map(function (mode) {
            var Icon = ICONS[mode];
            var label = MODE_LABELS[mode];
            var isActive = value === mode;
            return (React.createElement("button", { key: mode, type: "button", className: 'product-grid-view-toggle__btn' +
                    (isActive ? ' product-grid-view-toggle__btn--active' : ''), "aria-pressed": isActive, "aria-label": label, title: label, onClick: function () { return onChange(mode); } },
                React.createElement(Icon, null)));
        })));
};
export default ProductGridViewToggle;
//# sourceMappingURL=ProductGridViewToggle.js.map